import { Button, Col, Modal, Typography, usePrevTheme, Row } from '@prev/ui-kit'
import React from 'react'
const { Text } = Typography
import { CheckCircleOutlined } from '@ant-design/icons'

interface SuccessFeedbackProps {
  success: boolean
  handleSuccess: (props: boolean) => void
  handleOfficeModal: (props: boolean) => void
}

export const SuccessFeedback = (props: SuccessFeedbackProps): JSX.Element => {
  const { theme } = usePrevTheme()
  const { handleSuccess, success, handleOfficeModal } = props

  const handleNewEmail = (): void => {
    handleOfficeModal(true)
    handleSuccess(false)
  }

  const handleClose = (): void => {
    handleSuccess(false)
  }

  return (
    <Modal
      data-testid="modal-success"
      open={success}
      onCancel={handleClose}
      closeIcon={false}
      styles={{
        content: { padding: '24px 24px 16px 24px', backgroundColor: theme.color.surface.container.default },
        header: { backgroundColor: theme.color.surface.container.default },
      }}
      width={480}
      footer={[
        <Button
          key="novoEmail"
          type="subtle"
          data-testid="btn-novo-email"
          onClick={handleNewEmail}
          style={{ color: theme.color.text.default }}
        >
          Solicitar novo e-mail
        </Button>,
        <Button key="fechar" data-testid="btn-fechar" type="primary" onClick={handleClose} style={{ color: '#FDFDFF' }}>
          Fechar
        </Button>,
      ]}
      title={
        <Row style={{ gap: '16px' }} align="middle">
          <CheckCircleOutlined style={{ color: theme.color.icon.accent.green, fontSize: '42px' }} />
          <Text emphasis>E-mail enviado</Text>
        </Row>
      }
    >
      <Col
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '20px',
          marginTop: '10px',
        }}
      >
        <Text color={theme.color.text.subtle}>Verifique sua caixa de entrada.</Text>
        <Text color={theme.color.text.subtle}>
          Caso o e-mail não chegue em até 15 minutos, basta solicitar novamente.
        </Text>
      </Col>
    </Modal>
  )
}
